import { render } from "./RegisterCourseDialog.vue?vue&type=template&id=65e1860f"
import script from "./RegisterCourseDialog.vue?vue&type=script&lang=js"
export * from "./RegisterCourseDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__